"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveEffect = void 0;
var react_1 = require("react");
/**
 * Helper function monitoring the component unmount.
 * The status object is passed by reference and the active property is set to false when the component is unmounted.
 * Useful to prevent state update after component unmount.
 */
function useActiveEffect(cb, deps) {
    react_1.useEffect(function () {
        var status = { active: true };
        cb(status);
        return function () {
            status.active = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
exports.useActiveEffect = useActiveEffect;
//# sourceMappingURL=use-active-effect.js.map